import { forwardRef } from 'react';
import { Props } from '@components/toggle/src/toggle.type';
import { ToggleButton } from '@components/toggle/src/toggle-button';
import classNames from 'classnames';

export const Toggle = forwardRef<HTMLButtonElement, Props>(
  ({ value, onChange, isEnabledText, isNotEnabledText, disabled = false, switchValues }, enabledButtonRef) => {
    return (
      <span className={classNames('flex flex-row shadow-sm rounded-full w-max bg-tertiary')}>
        {!switchValues && (
          <ToggleButton
            ref={value ? null : enabledButtonRef}
            enabled={!value}
            setEnabled={() => onChange(false)}
            disabled={disabled}>
            {isEnabledText}
          </ToggleButton>
        )}
        <ToggleButton
          ref={value ? enabledButtonRef : null}
          enabled={value}
          setEnabled={() => onChange(true)}
          disabled={disabled}>
          {isNotEnabledText}
        </ToggleButton>
        {switchValues && (
          <ToggleButton
            ref={value ? null : enabledButtonRef}
            enabled={!value}
            setEnabled={() => onChange(false)}
            disabled={disabled}>
            {isEnabledText}
          </ToggleButton>
        )}
      </span>
    );
  }
);

Toggle.displayName = 'Toggle';
